/** Customer-facing readable ref: proposal reference with leading `CLARI-` removed. */

export function toProposalLinkBReadableRef(proposalRef: string | null | undefined): string {
  const raw = String(proposalRef ?? "").trim();
  if (!raw) return "";
  return raw.replace(/^CLARI-/i, "");
}

export function fromProposalLinkBReadableRef(readableRef: string | null | undefined): string {
  const raw = String(readableRef ?? "").trim();
  if (!raw) return "";
  if (/^CLARI-/i.test(raw)) return raw;
  return `CLARI-${raw}`;
}

export function normalizeProposalLinkBReadableRef(readableRef: string | null | undefined): string {
  return toProposalLinkBReadableRef(readableRef).toUpperCase();
}
